import { Link, Text } from "@radix-ui/themes";

export default function ZHistoryText() {
  return (
    <>
      <div className="container py-3">
        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              The idea of the Center Interstices arose from the background of the platform of Research and Intellectual Dialogue at the 
               &nbsp;
              <Link href="https://www.fondationalaindanielou.org/" target="_blank">
                Alain Daniélou Foundation 
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
              </Link>
              . 
              This platform was created by Adrián Navigante in 2015 and its purpose was to bridge the gap, in the best possible way, between Western scholarship with its modern, secular impetus, and non-Western knowledge systems of traditional imprint. 

            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              At first, the platform was focused on research and interactions within the India-Europe axis. However, the complexity of both the European context and the Indian subcontinent - as well as the tension between different world-configurations, methods and systems of knowledge led to a widening of the gaps rather than filling them with cultural strategies of understanding (which are in most cases masks of domination). 
              Amanda Viana de Sousa joined that platform in 2018, 
              and the platform's horizon was progressively broadened ever since toward
              a transversal approach of non-Western cultures, including South-Asian, West-African and Amerindian traditions. 
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              The transversal approach does not claim 
              knowledge through objectivity but rather through a different dimension of subjectivity
              (as transformation process) in the context of cultural interpenetration and reciprocal influence. 
              This is not to equate with
              a comparative method of scholarly provenance, since the point of departure is not two units to be related but a line cutting across dissimilar territories. 
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              The philosophy of Interstices, which follows that of the previous platform at FAD, differs from
              what is usually practiced in the West: instead of an asymmetrical approach, that is, an objective description or historical-philological reconstruction of the 
              autochthonous cultures in question, the central aim is to engage in a symmetrical interaction with them, avoiding
              both shallow essentializations (like that of Perennialists) and hasty identifications (like those of some New Age groups), seeking above all to work on the ‘gaps’ between our world-configuration and that of the others – since no world-configuration is a closed and once-and-for-all defined system. 
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              It is in the in-between places where the most promising factors are found in building a future without the prejudices of the past.
            </Text>
          </div>
        </div>

      </div>
  
    </>
  )
}
